import Mask from '@reactour/mask';
import { useEffect, useState } from 'react';

interface Props {
  selector?: string;
  padding?: number | number[];
}

export default function OnboardingMask({ selector = 'something-that-does-not-exist', padding = 0 }: Props) {
  const [el, setEl] = useState<Element | null>();
  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    const element = document.querySelector(selector);
    if (element) {
      setEl(element);
    } else {
      const observer = new MutationObserver((mutationsList, observer) => {
        const element = document.querySelector(selector);
        if (element) {
          observer.disconnect();
          setEl(element);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      // Clean up the observer on component unmount
      return () => observer.disconnect();
    }
  }, []);

  if (!el) {
    return (
      <Mask
        className="!z-40 rounded"
        sizes={{
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          width: 0,
          height: 0,
          x: 0,
          y: 0,
        }}
        padding={padding}
      />
    );
  } else {
    return <Mask className="!z-40 rounded" sizes={el.getBoundingClientRect()} padding={padding} />;
  }
}
